// Dependencies
import React, { useEffect, useState, useMemo } from "react";

// Modules

// App
import { apiEndpoints } from "../../config";

import PostEdit from "../../partials/posts/postEdit";

export default function QuizEdit() {
  const [editorContent, setEditorContent] = useState("");
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (editorContent && editorContent.blocks) {
      const questions = editorContent.blocks
        .filter((block) => block.type === "question")
        .map((questionBlock) => {
          return { ...questionBlock.data };
        });
      setQuestions(questions);
    }
  }, [editorContent]);

  const extraFields = useMemo(() => {
     return  {field_question: questions.length > 0 ? questions : undefined}
    }, [questions]);

  return (
    <PostEdit
      entityType={"quiz"}
      apiEndpoint={apiEndpoints.quiz}
      screenClassName={"quizzes"}
      categoryTitle={"Quiz category"}
      categoryName={"field_quiz_category"}
      targetVid={"quiz_categories"}
      returnRoute={"/quizzes-creator"}
      backBtnText={"Quiz Library"}
      previewRoute={"/quizzes/preview"}
      logCustomEventType={"Quiz"}
      extraFields={extraFields}
      featuredImageEnabled={true}
      editorProps={{
        title: true,
        subtitle: true,
        summary: true,
        body: true,
        list: true,
        table: true,
        image: true,
        video: true,
        embed: true,
        rule: true,
        buttonGroup: true,
        chart: true,
        map: true,
        question: true,
      }}
      disablereactions={true}
      disableComments={true}
      setEntityEditorContent={(body) => {
        setEditorContent(body);
      }}
      imageBlockEnabled={true}
    ></PostEdit>
  );
}
